import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n\n  .slick-arrow {\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    width: ", ";\n    height: ", ";\n    border: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: 1;\n    color: transparent;\n    overflow: hidden;\n    background-position: center;\n    background-repeat: no-repeat;\n    outline: none;\n    cursor: pointer;\n    ", "\n\n    &.slick-prev {\n      left: ", ";\n      right: ", ";\n      background-image: url(", ");\n    }\n\n    &.slick-next {\n      left: ", ";\n      right: ", ";\n      background-image: url(", ");\n    }\n  }\n\n  .slick-dots {\n    position: ", ";\n    left: ", ";\n    bottom: ", ";\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    text-align: ", ";\n    list-style: none;\n    ", "\n\n    &.slick-thumb {\n      display: flex !important;\n      overflow: auto;\n      width: 100%;\n      bottom: auto;\n\n      li {\n        margin: ", ";\n\n        &.slick-active {\n          ", " {\n            border: ", ";\n            border-color: ", ";\n            box-sizing: border-box;\n          }\n        }\n      }\n    }\n\n    li {\n      position: relative;\n      display: inline-flex;\n      text-align: center;\n      vertical-align: top;\n\n      &.slick-active {\n        button {\n          width: ", ";\n          height: ", ";\n          border-radius: ", ";\n          background-color: ", ";\n        }\n      }\n\n      button {\n        display: block;\n        width: ", ";\n        height: ", ";\n        padding: 0;\n        margin: ", ";\n        color: transparent;\n        font-size: 0;\n        background-color: ", ";\n        border: ", ";\n        border-radius: ", ";\n        outline: none;\n        cursor: pointer;\n        -webkit-transition: all 0.5s;\n        transition: all 0.5s;\n      }\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  background-image: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 60%;\n  line-height: 1.5;\n  font-size: ", ";\n  color: ", ";\n  margin-top: 8px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 60%;\n  line-height: 1.5;\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  word-break: break-word;\n  height: inherit;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  ", "\n  ", "\n  ", "\n  background-repeat: no-repeat;\n  text-decoration: none;\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  z-index: 1;\n  border-radius: ", ";\n  font-size: ", ";\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import Slick from 'react-slick';
import styled from 'styled-components';
import { variant, color, background, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import 'slick-carousel/slick/slick.css';
import next from './next.svg';
import prev from './prev.svg';
import { useState } from 'react';
import { useCallback } from 'react';
var carouselIndexStyle = variant({
  key: 'carousel.index'
});
var carouselArrowStyle = variant({
  key: 'carousel.arrow'
});
var carouselDotsStyle = variant({
  key: 'carousel.dots'
});
var Wrap = styled.div(_templateObject());
var Index = styled.div(_templateObject2(), themeGet('carousel.index.top'), themeGet('carousel.index.right'), themeGet('carousel.index.bottom'), themeGet('carousel.index.left'), themeGet('carousel.index.padding'), themeGet('carousel.index.backgroundColor'), themeGet('carousel.index.color'), themeGet('carousel.index.borderRadius'), themeGet('carousel.index.fontSize'), carouselIndexStyle);
var SlideWrap = styled.a(_templateObject3(), layout, color, background);
SlideWrap.defaultProps = {
  height: '300px',
  color: 'white',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundColor: 'primaryLight'
};
var SlideContent = styled.div(_templateObject4());
var SlideTitle = styled.h2(_templateObject5(), themeGet('carousel.slideTitle.fontSize'), themeGet('carousel.slideTitle.fontWeight'), themeGet('carousel.slideTitle.color'));
var SlideDescription = styled.p(_templateObject6(), themeGet('carousel.slideDescription.fontSize'), themeGet('carousel.slideDescription.color'));

var Slide = function Slide(_ref) {
  var title = _ref.title,
      description = _ref.description,
      rest = _objectWithoutProperties(_ref, ["title", "description"]);

  return (
    /*#__PURE__*/
    React.createElement(SlideWrap, _extends({
      rel: "noopener",
      target: "_blank"
    }, rest),
    /*#__PURE__*/
    React.createElement(SlideContent, null,
    /*#__PURE__*/
    React.createElement(SlideTitle, null, title),
    /*#__PURE__*/
    React.createElement(SlideDescription, null, description)))
  );
};

var CustomPage = styled(SlideWrap)(_templateObject7(), themeGet('carousel.customPage.width'), themeGet('carousel.customPage.height'), function (props) {
  return props.backgroundImage;
});
var StyledSlick = styled(Slick)(_templateObject8(), themeGet('carousel.arrow.top'), themeGet('carousel.arrow.bottom'), themeGet('carousel.arrow.width'), themeGet('carousel.arrow.height'), themeGet('carousel.arrow.border'), themeGet('carousel.arrow.borderRadius'), themeGet('carousel.arrow.backgroundColor'), carouselArrowStyle, themeGet('carousel.arrow.prev.left'), themeGet('carousel.arrow.prev.right'), prev, themeGet('carousel.arrow.next.left'), themeGet('carousel.arrow.next.right'), next, themeGet('carousel.dots.position'), themeGet('carousel.dots.left'), themeGet('carousel.dots.bottom'), themeGet('carousel.dots.textAlign'), carouselDotsStyle, themeGet('carousel.customPage.margin'), CustomPage, themeGet('carousel.customPage.border'), themeGet('carousel.customPage.borderColor'), themeGet('carousel.dot.active.width'), themeGet('carousel.dot.active.height'), themeGet('carousel.dot.active.borderRadius'), themeGet('carousel.dot.active.backgroundColor'), themeGet('carousel.dot.width'), themeGet('carousel.dot.height'), themeGet('carousel.dot.margin'), themeGet('carousel.dot.backgroundColor'), themeGet('carousel.dot.border'), themeGet('carousel.dot.borderRadius'));
export var Carousel = function Carousel(_ref2) {
  var autoplay = _ref2.autoplay,
      autoplaySpeed = _ref2.autoplaySpeed,
      afterChange = _ref2.afterChange,
      beforeChange = _ref2.beforeChange,
      dots = _ref2.dots,
      arrows = _ref2.arrows,
      draggable = _ref2.draggable,
      children = _ref2.children,
      variant = _ref2.variant,
      index = _ref2.index;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var handleBeforeChange = useCallback(function (_, currentIndex) {
    setCurrentIndex(currentIndex);
    return beforeChange;
  }, [beforeChange]);
  var pages = React.Children.map(children, function (page) {
    return (
      /*#__PURE__*/
      React.createElement(CustomPage, {
        backgroundImage: page.props.backgroundImage
      })
    );
  });
  var total = React.Children.count(children);
  var galleryProps = variant === 'gallery' && {
    customPaging: function customPaging(i) {
      return pages[i];
    },
    dotsClass: 'slick-dots slick-thumb',
    responsive: [{
      breakpoint: 1032,
      settings: {
        dots: false
      }
    }]
  };
  var carouselVariant = variant === 'gallery' ? ['default', 'gallery'] : 'default';
  return (
    /*#__PURE__*/
    React.createElement(Wrap, null, index && total > 1 &&
    /*#__PURE__*/
    React.createElement(Index, {
      variant: carouselVariant
    }, currentIndex + 1, " / ", total),
    /*#__PURE__*/
    React.createElement(StyledSlick, _extends({}, galleryProps, {
      dots: dots,
      autoplaySpeed: autoplaySpeed,
      autoplay: autoplay,
      arrows: arrows,
      draggable: draggable,
      beforeChange: handleBeforeChange,
      afterChange: afterChange,
      variant: carouselVariant
    }), children))
  );
};
Carousel.defaultProps = {
  draggable: false,
  arrows: false,
  dots: true,
  autoplay: false,
  autoplaySpeed: 3000
};
Carousel.Slide = Slide;